import React, { useState } from "react";

import { SelectItem } from "@fronterahealth/frontera-ui-components";

import { ApiReportGoalChartTypeChoices } from "@api/graphql/types-and-hooks";
import { ShortTermGoalProgressGraph } from "@components/ShortTermGoalPanel/ShortTermGoalProgressGraph";
import { TargetProgressGraph } from "@components/TargetPanel/TargetProgressGraph";
import { convertReadableString } from "@components/forms/utils";

interface ProgrammingGoalChartProps {
  goalId: string;
  targetId: string;
}

export const ProgrammingGoalChart: React.FC<ProgrammingGoalChartProps> = ({ goalId, targetId }) => {
  const [selectedChart, setSelectedChart] = useState<SelectItem>({
    id: ApiReportGoalChartTypeChoices.Progress,
    primary: convertReadableString(ApiReportGoalChartTypeChoices.Progress),
  });

  if (!goalId) return null;

  return (
    <div className="w-full">
      {targetId ? (
        <TargetProgressGraph
          reportGoalId={goalId}
          target={{ id: targetId, summaryReviewed: false }}
          signedChartImageUrl=""
          forClientProgramming={true}
        />
      ) : (
        <ShortTermGoalProgressGraph
          reportGoal={{ id: goalId, summaryReviewed: false, summaryReviewedOn: null }}
          selectedChart={selectedChart}
          setSelectedChart={setSelectedChart}
          signedChartImageUrl=""
          forClientProgramming={true}
        />
      )}
    </div>
  );
};
